const ElementIds = {
    name: "CateringForm-name",
    email: "CateringForm-email",
    phone: "CateringForm-phone",
    deliveryCheckbox: "CateringForm-delivery-checkbox",
    deliverySection: "CateringForm-delivery-details",
    deliveryAddress: "CateringForm-delivery-address",
    deliveryTime: "CateringForm-delivery-time",
    pickupSection: "CateringForm-pickup-details",
    pickupTime: "CateringForm-pickup-time",
    quantity: "CateringForm-quantity",
    cateringFormError: "catering-form_error",
    cateringForm: "catering-form",
    cateringFormSubmitButton: "catering__button"
};

const Messages = {
    validation: {
        nameRequired: 'Name is required.',
        emailRequired: 'Email is required.',
        phoneRequired: 'Phone number is required.',
        deliveryAddressRequired: 'Delivery address is required.',
        deliveryTimeRequired: 'Ideal delivery time is required.',
        pickupTimeRequired: 'Estimated pickup time is required.',
        quantityRequired: 'Quantity is required.'
    },
};

const touchedFields = {
    name: false,
    email: false,
    phone: false,
    deliveryAddress: false,
    deliveryTime: false,
    pickupTime: false,
    quantity: false
};

document.addEventListener('DOMContentLoaded', () => {
    let validationTriggered = false;
    const nameInput = document.getElementById(ElementIds.name);
    const emailInput = document.getElementById(ElementIds.email);
    const phoneInput = document.getElementById(ElementIds.phone);
    const deliveryCheckbox = document.getElementById(ElementIds.deliveryCheckbox);
    const deliveryAddressInput = document.getElementById(ElementIds.deliveryAddress);
    const deliveryTimeInput = document.getElementById(ElementIds.deliveryTime);
    const pickupTimeInput = document.getElementById(ElementIds.pickupTime);
    const quantityInput = document.getElementById(ElementIds.quantity);
    const cateringFormError = document.getElementById(ElementIds.cateringFormError);
    const cateringForm = document.getElementById(ElementIds.cateringForm);
    const cateringFormSubmitButton = document.getElementById(ElementIds.cateringFormSubmitButton);
    const deliverySection = document.getElementById(ElementIds.deliverySection);
    const pickupSection = document.getElementById(ElementIds.pickupSection);
    
    let isDelivery = deliveryCheckbox.checked;  // current state

    /**
     * 
     * @param {Date} date
     * @returns {string} formatted datetime string
     */
    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const now = new Date();
    const formattedNow = formatDateTime(now);

    deliveryTimeInput.min = formattedNow;
    pickupTimeInput.min = formattedNow;


    function initInputs() {
        if (deliveryCheckbox.checked) {
            pickupSection.remove();
        }
        else {
            deliverySection.remove();
        }
    }

    function toggleInputs() {
        if (deliveryCheckbox.checked) {
            pickupSection.insertAdjacentElement("afterend", deliverySection)
            pickupSection.remove();
        } 
        else {
            deliverySection.insertAdjacentElement("afterend", pickupSection)
            deliverySection.remove();
        }
    }

    window.toggleInputs = toggleInputs;
    initInputs();

    /**
     * 
     * @param {string|undefined} name 
     * @param {Messages|undefined} message
     * @returns {string|undefined} errors
     */
    const validateField = (name, message) => {
        if(name){
            return undefined;
        }
        else{
            return message;
        }
    }

    const validateAndShowErrors = () => {
        const errors = validateForm(false);
        if (errors) {
            showError(errors);
        } else {
            hideError();
        }
    };

    nameInput.addEventListener('input', () => {
        touchedFields.name = true;
        validateAndShowErrors();
    });

    emailInput.addEventListener('input', () => {
        touchedFields.email = true;
        validateAndShowErrors();
    });

    phoneInput.addEventListener('input', () => {
        touchedFields.phone = true;
        validateAndShowErrors();
    });

    deliveryCheckbox.addEventListener('change', () => {
        isDelivery = deliveryCheckbox.checked;
        
        if (isDelivery) {
            touchedFields.pickupTime = false;
            pickupTimeInput.value = '';
        } 
        else {
            touchedFields.deliveryAddress = false;
            touchedFields.deliveryTime = false;
            deliveryAddressInput.value = '';
            deliveryTimeInput.value = '';
        }

        hideError();
        validateAndShowErrors();

    });

    deliveryAddressInput.addEventListener('input', () => {
        touchedFields.deliveryAddress = true;
        validateAndShowErrors();
    });

    deliveryTimeInput.addEventListener('input', () => {
        touchedFields.deliveryTime = true;
        validateAndShowErrors();
    });

    pickupTimeInput.addEventListener('input', () => {
        touchedFields.pickupTime = true;
        validateAndShowErrors();
    });

    quantityInput.addEventListener('input', () => {
        touchedFields.quantity = true;
        validateAndShowErrors();
    });

    cateringForm.addEventListener('submit', async (e) => {
        cateringFormSubmitButton.disabled = true;

        touchedFields.name = true;
        touchedFields.email = true;
        touchedFields.phone = true;
        touchedFields.deliveryAddress = true;
        touchedFields.deliveryTime = true;
        touchedFields.pickupTime = true;
        touchedFields.quantity = true;

        if (!validationTriggered) {
            validationTriggered = true;
        }
        const errors = validateForm();

        if (errors) {
            e.preventDefault();
            showError(errors);
            return false;
        } else {
            hideError();
        }
        cateringFormSubmitButton.disabled = false;
    });

    const hideError = () => {
        cateringFormError.textContent = '';
        cateringFormError.style.display = 'none';
    };
    /**
     * Method to show an error.
     * @param {string} error
     */
    const showError = (errors) => {
        if (!Array.isArray(errors)) {
            errors = [errors];
        }

        cateringFormError.innerHTML = `
            <ul style="margin: 0; padding-left: 1.2em;">
                ${errors.map(err => `<li>${err}</li>`).join('')}
            </ul>
        `;
        cateringFormError.style.display = 'block';
    };
    
    /**
     * Method to validate form and return error messages.
     * @returns {string[]|undefined} error messages
     */
    const validateForm = (showAll = false) => {
        const errors = [];
        // const isValid = cateringForm.reportValidity();
        const name = nameInput.value;
        const email = emailInput.value;
        const phone = phoneInput.value;
        const deliveryAddress = deliveryAddressInput.value;
        const deliveryTime = deliveryTimeInput.value;
        const pickupTime = pickupTimeInput.value;
        const quantity = quantityInput.value;

        if (showAll || touchedFields.name) {
            const nameError = validateField(name, Messages.validation.nameRequired);
            if (nameError) errors.push(nameError);
        }

        if (showAll || touchedFields.email) {
            const emailError = validateField(email, Messages.validation.emailRequired);
            if (emailError) errors.push(emailError);
        }

        if (showAll || touchedFields.phone) {
            const phoneError = validateField(phone, Messages.validation.phoneRequired);
            if (phoneError) errors.push(phoneError);
        }

        if (isDelivery) {
            if (showAll || touchedFields.deliveryAddress) {
                const deliveryAddressError = validateField(deliveryAddress, Messages.validation.deliveryAddressRequired);
                if (deliveryAddressError) errors.push(deliveryAddressError);
            }
            if (showAll || touchedFields.deliveryTime) {
                const deliveryTimeError = validateField(deliveryTime, Messages.validation.deliveryTimeRequired);
                if (deliveryTimeError) errors.push(deliveryTimeError);
            }
        } else {
            if (showAll || touchedFields.pickupTime) {
                const pickupTimeError = validateField(pickupTime, Messages.validation.pickupTimeRequired);
                if (pickupTimeError) errors.push(pickupTimeError);
            }
        }

        if (showAll || touchedFields.quantity) {
            const quantityError = validateField(quantity, Messages.validation.quantityRequired);
            if (quantityError) errors.push(quantityError);
        }
        
        if(errors.length){
            return errors
        }
        else{
            return undefined
        }
    }
})
